import { useTheme } from '@mui/material/styles';

import { Grid, Typography, useMediaQuery, Box } from '@mui/material';
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-lines */
// import { Grid, Typography, useMediaQuery } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { isAndroid, osVersion } from 'react-device-detect';
import PropTypes from 'prop-types';
import IdUploadSidebar from '../../Sidebar/IdUploadSidebar';

import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { CustomInput } from '../CustomInput/CustomInput';
import { CustomSelect } from '../CustomSelect/CustomSelect';
import { MobileInput } from '../MobileInput/MobileInput';
import { CustomDob } from '../CustomDob/CustomDob';
import { PersonalInformationStyles as classes } from './PersonalInformationStyles';
import { SSNAndroid } from '../SSN/SSNAndroid';
import { SSN } from '../SSN/SSN';
import { dgiMapping } from '../../../services/dgiMapping';
import { commonUtility, commonUtilityBooleanChk } from '../UtilityFunctions';
import {
  ALT_PHONE,
  FIRST_NAME,
  GENDER,
  INVALID_FORMAT_ERR,
  LAST_NAME,
  MANDATORY_FIELD_ERR,
  MARITAL_ST,
  MIDDLE_INIT,
  HOME_ADDRESS_TITLE,
  REQUIRED,
  SEC_LAST_NAME,
  UPLOAD_ID_PASSPORT,
  MOBILE_NUMBER,
  EMAIL,
  PROGRESA_CONTIGO,
  DATE_FORMAT_EN,
  DATE_FORMAT_ES,
  EN,
  HOME_ADDRESS_TITLE_PROG,
} from '../../../constants';
import { CommonStyles } from '../CommonStyles';
import { productMapping } from '../../../services/productMapping';
import { commonTernary, formatMaskedSSN, formatSSN, handleDOBchange } from '../../commonCode';

/** Personal is a child component to PersonalInformation
 */
function Personal(props) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const themes = useTheme();
  const { handleChange, vouchedTigger } = props;

  const {
    personalInformation,
    productName,
    setPersonalInformation,
    personalInformationErrors,
    setPersonalInformationErrors,
    setIsScreenTwoDirty,
    setIsScreenThreeDirty,
    setIsScreenFourDirty,
    setIsScreenFiveDirty,
    setIsBeneficiaryScreenDirty,
    setIsFundingScreenDirty,
    location,
    language,
    setFirstName,
    idUploadStatus,
    vouchedData,
    saveAppContactInfo,
    setSaveAppContactInfo,
    setSaveAppContactInfoErrors,
    setIsFeatureScreenDirty,
  } = leadGenerationContext;
  const commonStyles = CommonStyles(leadGenerationContext?.theme);

  const isMobile = useMediaQuery(themes?.breakpoints?.down('sm'), {
    defaultMatches: true,
  });
  /** SSN Handle change
   */
  const handleKeyDownSSN = (value) => {
    setIsScreenTwoDirty(true);
    setIsScreenThreeDirty(true);
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsBeneficiaryScreenDirty(true);
    setIsFundingScreenDirty(true);
    setIsFeatureScreenDirty(true);
    if (value.match(/^\d/)) {
      if (value.length <= 11) {
        setPersonalInformation((prevState) => ({ ...prevState, ssn: value }));
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          ssn: '',
        }));
        setSaveAppContactInfo((prevState) => ({ ...prevState, ssn: value }));
        setSaveAppContactInfoErrors((prevState) => ({
          ...prevState,
          ssn: '',
        }));
        if (value.length < 11) {
          setPersonalInformationErrors((prevState) => ({
            ...prevState,
            ssn: '* Social Security Number should have 9 digits',
          }));
          setSaveAppContactInfoErrors((prevState) => ({
            ...prevState,
            ssn: '* Social Security Number should have 9 digits',
          }));
        } else {
          setPersonalInformationErrors((prevState) => ({
            ...prevState,
            ssn: '',
          }));
          setSaveAppContactInfoErrors((prevState) => ({
            ...prevState,
            ssn: '',
          }));
        }
      }
    } else if ((value ?? '') === '') {
      setPersonalInformation((prevState) => ({ ...prevState, ssn: '' }));
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        ssn: MANDATORY_FIELD_ERR,
      }));
      setSaveAppContactInfo((prevState) => ({ ...prevState, ssn: '' }));
      setSaveAppContactInfoErrors((prevState) => ({
        ...prevState,
        ssn: MANDATORY_FIELD_ERR,
      }));
    } else {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        ssn: INVALID_FORMAT_ERR,
      }));
      setSaveAppContactInfoErrors((prevState) => ({
        ...prevState,
        ssn: INVALID_FORMAT_ERR,
      }));
    }
  };
  /** SSN Handle change for android
   */
  const handleKeyDownSSNAndroid = (e) => {
    const isMasked = e.target.value.includes('X');

    let value = isMasked
      ? formatMaskedSSN(
          e,
          personalInformation,
          INVALID_FORMAT_ERR,
          setPersonalInformationErrors,
          setSaveAppContactInfoErrors
        )
      : e.target.value;

    setIsScreenTwoDirty(true);
    setIsScreenThreeDirty(true);
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsBeneficiaryScreenDirty(true);
    setIsFundingScreenDirty(true);
    setIsFeatureScreenDirty(true);
    if (value.match(/^[0-9-]*$/)) {
      value = isMasked ? value : formatSSN(e, personalInformation);
      if (value.length <= 11) {
        leadGenerationContext.setPersonalInformation((prevState) => ({ ...prevState, ssn: value }));
        leadGenerationContext.setPersonalInformationErrors((prevState) => ({
          ...prevState,
          ssn: '',
        }));
        setSaveAppContactInfo((prevState) => ({ ...prevState, ssn: value }));
        setSaveAppContactInfoErrors((prevState) => ({
          ...prevState,
          ssn: '',
        }));
        if (value.length < 11 && value.length !== 0) {
          leadGenerationContext.setPersonalInformationErrors((prevState) => ({
            ...prevState,
            ssn: '* Social Security Number should have 9 digits',
          }));
          setSaveAppContactInfoErrors((prevState) => ({
            ...prevState,
            ssn: '* Social Security Number should have 9 digits',
          }));
        } else if (value.length === 0) {
          leadGenerationContext.setPersonalInformationErrors((prevState) => ({
            ...prevState,
            ssn: MANDATORY_FIELD_ERR,
          }));
          setSaveAppContactInfoErrors((prevState) => ({
            ...prevState,
            ssn: MANDATORY_FIELD_ERR,
          }));
        } else {
          leadGenerationContext.setPersonalInformationErrors((prevState) => ({
            ...prevState,
            ssn: '',
          }));
          setSaveAppContactInfoErrors((prevState) => ({
            ...prevState,
            ssn: '',
          }));
        }
      }
    } else if ((value ?? '') === '') {
      leadGenerationContext.setPersonalInformation((prevState) => ({ ...prevState, ssn: '' }));
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        ssn: MANDATORY_FIELD_ERR,
      }));
      setSaveAppContactInfo((prevState) => ({ ...prevState, ssn: '' }));
      setSaveAppContactInfoErrors((prevState) => ({
        ...prevState,
        ssn: MANDATORY_FIELD_ERR,
      }));
    } else {
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        ssn: INVALID_FORMAT_ERR,
      }));
      setSaveAppContactInfoErrors((prevState) => ({
        ...prevState,
        ssn: INVALID_FORMAT_ERR,
      }));
    }
  };

  const isMobileCall = () => {
    if (isMobile) {
      return 2;
    }
    return 3;
  };
  const headingClassName = () => {
    let classname;
    if (leadGenerationContext.isIE) {
      classname = commonStyles.IEPersonal_heading_info;
    } else {
      classname = classes.personal_heading_info;
    }
    return classname;
  };

  const headingClassNameTwo = () => {
    let classname;
    if (leadGenerationContext?.vouchedIdErrorStatus) {
      classname = classes.mar_top_adj;
    } else {
      classname = '';
    }
    return classname;
  };

  const errorContigo = () => {
    let jsxError;
    if (personalInformationErrors?.areaCode) {
      jsxError = (
        <Box component="span" role="alert" sx={classes.error_message} data-testid="areacode-error">
          {t(personalInformationErrors?.areaCode, {
            defaultValue: personalInformationErrors?.areaCode,
          })}
        </Box>
      );
    } else {
      jsxError = (
        <Box component="span" role="alert" sx={classes.error_message} data-testid="phone-error">
          {t(personalInformationErrors?.phone, {
            defaultValue: personalInformationErrors?.phone,
          })}
        </Box>
      );
    }
    return jsxError;
  };
  const returnIDUpload = () => {
    let jsx;
    if (!leadGenerationContext.isIE) {
      jsx = (
        <Grid
          size={{ xs: 12, sm: 12, md: 5, lg: 5 }}
          role="section"
          aria-describedby="idDescText idSubDescText"
          aria-roledescription={t(UPLOAD_ID_PASSPORT, {
            defaultValue: UPLOAD_ID_PASSPORT,
          })}
          sx={classes.idUploadPosition}
          data-testid="uploadTestId"
        >
          <IdUploadSidebar
            vouchedTigger={vouchedTigger}
            uploadSuccessStatus={personalInformation?.uploadSuccessStatus}
          />
        </Grid>
      );
    } else {
      jsx = '';
    }
    return jsx;
  };
  const returnIDUploadNoMobile = () => {
    let jsx;
    if (!leadGenerationContext.isIE) {
      jsx = (
        <Grid
          size={{ xs: 12, sm: 12, md: 5, lg: 5 }}
          role="section"
          aria-describedby="idDescText idSubDescText"
          aria-roledescription={t(UPLOAD_ID_PASSPORT, {
            defaultValue: UPLOAD_ID_PASSPORT,
          })}
          sx={classes.idUploadPosition}
          data-testid="uploadTestId"
        >
          <IdUploadSidebar
            vouchedTigger={vouchedTigger}
            uploadSuccessStatus={personalInformation?.uploadSuccessStatus}
          />
        </Grid>
      );
    } else {
      jsx = '';
    }
    return jsx;
  };
  const errorNonConti = () => {
    let jsxError;
    if (personalInformationErrors?.altAreaCode) {
      jsxError = (
        <Box
          component="span"
          role="alert"
          sx={classes.error_message}
          data-testid="altAreaCodeError"
        >
          {t(personalInformationErrors?.altAreaCode, {
            defaultValue: personalInformationErrors?.altAreaCode,
          })}
        </Box>
      );
    } else {
      jsxError = (
        <Box component="span" role="alert" sx={classes.error_message} data-testid="altPhoneError">
          {t(personalInformationErrors?.altPhone, {
            defaultValue: personalInformationErrors?.altPhone,
          })}
        </Box>
      );
    }
    return jsxError;
  };
  const renderPhoneNumber = () => {
    let jsxContent;
    if (productMapping(leadGenerationContext.productName) === PROGRESA_CONTIGO) {
      jsxContent = (
        <Grid size={{ xs: 12, md: 12 }} sx={classes.inputs_grid_margin}>
          <MobileInput
            id="phone"
            dataTestId="phone_id"
            required
            ariaLabelForInputLabel={`${t(MOBILE_NUMBER, {
              defaultValue: MOBILE_NUMBER,
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            label={t(MOBILE_NUMBER, { defaultValue: MOBILE_NUMBER })}
            location={location || 'PR'}
            handleChange={(e) => handleChange(e, leadGenerationContext)}
            placeholder={t('Enter Mobile Number', {
              defaultValue: 'Enter Mobile Number',
            })}
            fullWidth
            phoneValue={commonTernary(personalInformation?.phone, personalInformation.phone, '')}
            maxLength={commonTernary(location && location === 'VI', 10, 7)}
            inputMode="numeric"
            phoneError={personalInformationErrors?.phone}
            maxLengthOfAreaCode={3}
            areaCodeInputMode="numeric"
            areaCodeAriaLabel={`${t('Area Code', {
              defaultValue: 'Area Code',
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            areaCodeId="areaCode"
            areaCode={commonTernary(
              personalInformation?.areaCode,
              personalInformation.areaCode,
              ''
            )}
          />
          {errorContigo()}
        </Grid>
      );
    } else {
      jsxContent = (
        <Grid size={{ xs: 12, md: 12 }} sx={classes.inputs_grid_margin}>
          <MobileInput
            id="altPhone"
            dataTestId="altAreaCode_id"
            required={false}
            ariaLabelForInputLabel={`${t(ALT_PHONE, {
              defaultValue: ALT_PHONE,
            })}`}
            label={t(ALT_PHONE, {
              defaultValue: ALT_PHONE,
            })}
            location={location || 'PR'}
            handleChange={(e) => handleChange(e, leadGenerationContext)}
            placeholder={t('Enter Phone Number', {
              defaultValue: 'Enter Phone Number',
            })}
            fullWidth
            phoneValue={commonUtility(personalInformation?.altPhone)}
            maxLength={commonTernary(location && location === 'VI', 10, 7)}
            inputMode="numeric"
            phoneError={personalInformationErrors?.altPhone}
            maxLengthOfAreaCode={3}
            areaCodeInputMode="numeric"
            areaCodeAriaLabel={`${t('Area Code', {
              defaultValue: 'Area Code',
            })}`}
            areaCodeId="altAreaCode"
            areaCode={commonTernary(
              personalInformation?.altAreaCode,
              personalInformation.altAreaCode,
              ''
            )}
          />
          {errorNonConti()}
        </Grid>
      );
    }
    return jsxContent;
  };

  const getFirstName = commonUtility(personalInformation?.firstName);
  return (
    /**
     *  Personal component JSX content */
    <Box sx={classes.personal_info_grid_margin}>
      <Grid container spacing={0} sx={commonStyles.personalPageWrapper} data-page="personal-info">
        <Grid container>
          <Grid size={{ xs: 12 }}>
            <Typography
              sx={{
                ...classes.form_heading_info,
                ...headingClassName(),
                ...headingClassNameTwo(),
              }}
              id="letsStartheading"
              variant="h2"
              aria-label={t(HOME_ADDRESS_TITLE, {
                defaultValue: HOME_ADDRESS_TITLE,
              })}
            >
              {productMapping(productName) === 'Elite Account'
                ? t('We’d love Prog', {
                    defaultValue: HOME_ADDRESS_TITLE_PROG,
                    nsSeparator: '|',
                  })
                : t(HOME_ADDRESS_TITLE, { defaultValue: HOME_ADDRESS_TITLE })}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid container sx={classes.fieldsGrid} size={{ xs: 12, sm: 12, md: 7, lg: 7 }}>
            <Grid container role="region" aria-labelledby="letsStartheading">
              {commonTernary(isMobile, returnIDUpload(), '')}
              <Grid container spacing={isMobileCall()}>
                <Grid size={{ xs: 12, md: 12 }} sx={classes.inputs_grid_margin}>
                  <CustomInput
                    id="firstName"
                    dataTestId="firstName_id"
                    required
                    inputLabelAriaLabel={`${t(FIRST_NAME, {
                      defaultValue: FIRST_NAME,
                    })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                    label={t(FIRST_NAME, { defaultValue: FIRST_NAME })}
                    autoFocus={false}
                    handleChange={(e) => handleChange(e, leadGenerationContext)}
                    handleBlur={() => setFirstName(getFirstName)}
                    placeholder={t('Enter First Name', {
                      defaultValue: 'Enter First Name',
                    })}
                    disabled={!!idUploadStatus && vouchedData?.firstName !== null}
                    fullWidth
                    inputProps={{ maxLength: 10, 'data-testid': 'firstName' }}
                    value={commonUtility(personalInformation?.firstName)}
                    error={commonUtility(personalInformationErrors.firstName)}
                  />
                  <Box
                    component="span"
                    sx={classes.error_message}
                    role="alert"
                    data-testid="firstNameError"
                  >
                    {t(personalInformationErrors?.firstName, {
                      defaultValue: personalInformationErrors?.firstName,
                    })}
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 12 }} sx={classes.inputs_grid_margin}>
                  <CustomInput
                    id="middleName"
                    dataTestId="middleName_id"
                    required={false}
                    inputLabelAriaLabel={`${t(MIDDLE_INIT, {
                      defaultValue: MIDDLE_INIT,
                    })}`}
                    label={t(MIDDLE_INIT, {
                      defaultValue: MIDDLE_INIT,
                    })}
                    InputClassName={classes.middleName}
                    disabled={commonUtilityBooleanChk(
                      idUploadStatus &&
                        vouchedData?.middleName !== null &&
                        vouchedData?.middleName !== undefined
                    )}
                    autoFocus={false}
                    handleChange={(e) => handleChange(e, leadGenerationContext)}
                    placeholder={t('Enter Middle Initial', {
                      defaultValue: 'Enter Middle Initial',
                    })}
                    fullWidth
                    inputProps={{ maxLength: 1, 'data-testid': 'middleName' }}
                    value={commonUtility(personalInformation?.middleName)}
                    error={commonUtility(personalInformationErrors?.middleName)}
                  />
                  <Box
                    component="span"
                    sx={classes.error_message}
                    role="alert"
                    data-testid="middleNameError"
                  >
                    {t(personalInformationErrors?.middleName, {
                      defaultValue: personalInformationErrors?.middleName,
                    })}
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 12 }} sx={classes.inputs_grid_margin}>
                  <CustomInput
                    id="lastName"
                    dataTestId="lastName_id"
                    required
                    inputLabelAriaLabel={`${t(LAST_NAME, {
                      defaultValue: LAST_NAME,
                    })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                    label={t(LAST_NAME, { defaultValue: LAST_NAME })}
                    handleChange={(e) => handleChange(e, leadGenerationContext)}
                    disabled={commonUtilityBooleanChk(
                      (idUploadStatus && vouchedData?.lastName !== null) ||
                        leadGenerationContext.savedDataFlow
                    )}
                    placeholder={t('Enter Last Name', {
                      defaultValue: 'Enter Last Name',
                    })}
                    fullWidth
                    inputProps={{ maxLength: 15, 'data-testid': 'lastName' }}
                    value={personalInformation?.lastName ? personalInformation?.lastName : ''}
                    error={
                      personalInformationErrors?.lastName ? personalInformationErrors.lastName : ''
                    }
                  />
                  <Box
                    component="span"
                    sx={classes.error_message}
                    role="alert"
                    data-testid="lastNameError"
                  >
                    {t(personalInformationErrors?.lastName, {
                      defaultValue: personalInformationErrors?.lastName,
                    })}
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 12 }} sx={classes.inputs_grid_margin}>
                  <CustomInput
                    id="secondLastName"
                    dataTestId="secondLastName_id"
                    required={commonUtilityBooleanChk(
                      dgiMapping(leadGenerationContext.productName)
                    )}
                    inputLabelAriaLabel={`${t(SEC_LAST_NAME, {
                      defaultValue: SEC_LAST_NAME,
                    })}`}
                    label={t(SEC_LAST_NAME, {
                      defaultValue: SEC_LAST_NAME,
                    })}
                    handleChange={(e) => handleChange(e, leadGenerationContext)}
                    placeholder={t('Enter Second Last Name', {
                      defaultValue: 'Enter Second Last Name',
                    })}
                    fullWidth
                    inputProps={{
                      maxLength: 10,
                      'data-testid': 'secondLastName',
                    }}
                    value={commonUtility(personalInformation?.secondLastName)}
                    error={commonUtility(personalInformationErrors?.secondLastName)}
                  />
                  <Box
                    component="span"
                    sx={classes.error_message}
                    role="alert"
                    data-testid="secondLastNameError"
                  >
                    {t(personalInformationErrors?.secondLastName, {
                      defaultValue: personalInformationErrors?.secondLastName,
                    })}
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: 12 }} sx={classes.inputs_grid_margin}>
                  <CustomSelect
                    id="gender"
                    dataTestId="gender_id"
                    required
                    inputLabelAriaLabel={`${t(GENDER, {
                      defaultValue: GENDER,
                    })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                    label={t(GENDER, { defaultValue: GENDER })}
                    options={['Female', 'Male']}
                    handleChange={(e) => handleChange(e, leadGenerationContext)}
                    fullWidth
                    disabled={commonUtilityBooleanChk(
                      (idUploadStatus &&
                        (vouchedData?.gender?.gender === 'woman' ||
                          vouchedData?.gender?.gender === 'man')) ||
                        (vouchedData?.gender?.gender !== null &&
                          (leadGenerationContext.savedDataFlow ||
                            leadGenerationContext.isApplicationSaved))
                    )}
                    value={commonUtility(personalInformation?.gender)}
                    error={personalInformationErrors?.gender}
                    selectAriaLabel={`${t('Aria Label Gender', {
                      defaultValue: 'Gender Required Select Gender dropdown menu button',
                    })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                  />
                  <Box
                    component="span"
                    role="alert"
                    sx={classes.error_message}
                    data-testid="genderError"
                  >
                    {t(personalInformationErrors?.gender, {
                      defaultValue: personalInformationErrors?.gender,
                    })}
                  </Box>
                </Grid>

                {renderPhoneNumber()}

                {productMapping(leadGenerationContext.productName) === PROGRESA_CONTIGO && (
                  <Grid size={{ xs: 12, md: 12 }} sx={classes.inputs_grid_margin}>
                    <CustomInput
                      id="email"
                      dataTestId="email_id"
                      required
                      inputLabelAriaLabel={`${t(EMAIL, {
                        defaultValue: EMAIL,
                      })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                      label={t(EMAIL, {
                        defaultValue: EMAIL,
                      })}
                      handleChange={(e) => handleChange(e, leadGenerationContext)}
                      placeholder={t('Enter Email Address', {
                        defaultValue: 'Enter Email Address',
                      })}
                      fullWidth
                      inputProps={{ 'data-testid': 'email', maxLength: 40 }}
                      value={commonTernary(
                        personalInformation?.email,
                        personalInformation.email,
                        ''
                      )}
                      error={commonTernary(
                        personalInformationErrors?.email,
                        personalInformationErrors.email,
                        ''
                      )}
                    />
                    <Box
                      component="span"
                      role="alert"
                      sx={classes.error_message}
                      data-testid="email-error"
                    >
                      {t(personalInformationErrors?.email, {
                        defaultValue: personalInformationErrors?.email,
                      })}
                    </Box>
                  </Grid>
                )}

                <Grid
                  size={{ xs: 12, md: 12 }}
                  sx={[classes.inputs_grid_margin, 'dob-input-adjust']}
                >
                  <Grid size={{ xs: 12 }}>
                    {isAndroid && osVersion?.split('.')[0] <= 10 ? (
                      <SSNAndroid
                        handleKeyDown={handleKeyDownSSNAndroid}
                        disabled={commonUtilityBooleanChk(
                          (saveAppContactInfo?.ssn !== '' &&
                            leadGenerationContext.isApplicationSaved) ||
                            leadGenerationContext.savedDataFlow
                        )}
                        error={commonUtility(personalInformationErrors.ssn)}
                        ssn={personalInformation.ssn}
                        id="ssn"
                      />
                    ) : (
                      <SSN
                        handleKeyDown={handleKeyDownSSN}
                        disabled={commonUtilityBooleanChk(
                          (saveAppContactInfo?.ssn !== '' &&
                            leadGenerationContext.isApplicationSaved) ||
                            leadGenerationContext.savedDataFlow
                        )}
                        error={commonUtility(personalInformationErrors.ssn)}
                        ssn={personalInformation.ssn}
                        id="ssn"
                      />
                    )}

                    <Box component="span" sx={classes.error_message} role="alert">
                      {t(personalInformationErrors?.ssn, {
                        defaultValue: personalInformationErrors?.ssn,
                      })}
                    </Box>
                  </Grid>
                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>
                  <CustomDob
                    label={t(`Date of birth`, {
                      defaultValue: `Date of birth`,
                    })}
                    id="dob"
                    maxDatePicker={new Date()}
                    placeholder={commonTernary(
                      language === EN,
                      t(DATE_FORMAT_EN, { defaultValue: DATE_FORMAT_EN }),
                      t(DATE_FORMAT_ES, { defaultValue: DATE_FORMAT_ES })
                    )}
                    inputFormat={commonTernary(
                      language === EN,
                      t('MM/DD/YYYY', { defaultValue: 'MM/DD/YYYY' }),
                      t('DD/MM/YYYY', { defaultValue: 'DD/MM/YYYY' })
                    )}
                    dataTestIdForLabel="dobTestId"
                    dataTestId="date-of-birth"
                    value={personalInformation.dob}
                    onChange={(newValue) => handleDOBchange(newValue, leadGenerationContext)}
                    fullWidth
                    required
                    language={language}
                    disabled={commonUtilityBooleanChk(
                      (idUploadStatus && vouchedData?.birthDate !== null) ||
                        leadGenerationContext.savedDataFlow ||
                        (saveAppContactInfo?.dob !== '' && leadGenerationContext.isApplicationSaved)
                    )}
                    dob={commonTernary(personalInformation?.dob, personalInformation.dob, '')}
                    errorBorder={commonUtility(personalInformationErrors?.dob)}
                  />
                  <Box
                    component="span"
                    role="alert"
                    tabIndex="-1"
                    sx={classes.error_message}
                    data-testid="dobError"
                  >
                    {t(personalInformationErrors?.dob, {
                      defaultValue: personalInformationErrors?.dob,
                    })}
                  </Box>
                </Grid>
                {/* </Grid> */}
                {dgiMapping(leadGenerationContext.productName) ? (
                  <Grid size={{ xs: 12, md: 12 }} sx={classes.inputs_grid_margin}>
                    <Grid size={{ xs: 12 }}>
                      <CustomSelect
                        id="maritalStatus"
                        dataTestId="maritalStatus_id"
                        required
                        inputLabelAriaLabel={`${t(MARITAL_ST, {
                          defaultValue: MARITAL_ST,
                        })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                        label={t(MARITAL_ST, { defaultValue: MARITAL_ST })}
                        options={['Married', 'Unmarried']}
                        handleChange={(e) => handleChange(e, leadGenerationContext)}
                        fullWidth
                        value={commonUtility(personalInformation?.maritalStatus)}
                        selectAriaLabel={`${t('Aria Label Marital Status', {
                          defaultValue:
                            'Marital Status Required Select Marital Status dropdown menu button',
                        })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                      />
                      <Box
                        component="span"
                        role="alert"
                        sx={classes.error_message}
                        data-testid="maritalStatusError"
                      >
                        {t(personalInformationErrors?.maritalStatus, {
                          defaultValue: personalInformationErrors?.maritalStatus,
                        })}
                      </Box>
                    </Grid>
                  </Grid>
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
          </Grid>
          {!isMobile ? returnIDUploadNoMobile() : ''}
        </Grid>
      </Grid>
    </Box>
  );
}

export default Personal;

Personal.propTypes = {
  handleChange: PropTypes.func,
  vouchedTigger: PropTypes.func,
};
